import { useSearchParams } from "react-router-dom"

import Style from "./style"
import rangeCalculator from "./lib/rangeCalculator"
import usePagenation from "./model/usePagenation"

import previousActiveIIcon from "./asset/previousActiveIIcon.svg"
import nextActiveIcon from "./asset/nextActiveIcon.svg"

const Pagenation = ({ maxPage }) => {
    const [searchParam] = useSearchParams()
    const nowPage = searchParam.get("page")

    const range = rangeCalculator(nowPage, maxPage)
    const [prePageEvent, movePageEvent, nextPageEvent] = usePagenation(nowPage, maxPage)

    return (
        <>
            {maxPage > 1 &&
                <Style.Wrapper>
                    {nowPage > 1 &&
                        <button onClick={prePageEvent}>
                            <img src={previousActiveIIcon} />
                        </button>
                    }

                    <Style.PageButtonDiv>
                        {range?.map((elem) =>
                            <Style.PageButton $active={parseInt(nowPage) === elem} onClick={() => movePageEvent(elem)}>{elem}</Style.PageButton>
                        )}
                    </Style.PageButtonDiv>

                    {nowPage < maxPage &&
                        <button onClick={nextPageEvent}>
                            <img src={nextActiveIcon} />
                        </button>
                    }
                </Style.Wrapper>
            }
        </>
    )
}

export default Pagenation